"use client";

import { queryOptions, useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import { fetchLibrary, fetchDashboardOverview, fetchMyOrders, getMyStats } from "./api";

// The page reads as options, so a menu item's prefetch (`../prefetch.ts`,
// `AD-DSH02`) asks with the very key and function its page will.
export function libraryQuery(token?: string) {
  return queryOptions({ queryKey: queryKeys.me.library, queryFn: () => fetchLibrary(token) });
}

export function myOrdersQuery(opts: { page?: number; limit?: number; status?: string }, token?: string) {
  return queryOptions({ queryKey: queryKeys.me.orders(opts), queryFn: () => fetchMyOrders(opts, token) });
}

export function myStatsQuery(token?: string) {
  return queryOptions({
    queryKey: queryKeys.me.stats,
    queryFn: () => getMyStats(token),
    staleTime: 5 * 60 * 1000,
  });
}

export function useLibrary(token?: string) {
  return useQuery({ ...libraryQuery(token), enabled: !!token });
}

export function useDashboardOverview(token?: string) {
  return useQuery({
    queryKey: queryKeys.dashboard.overview,
    queryFn: () => fetchDashboardOverview(token),
    enabled: !!token,
  });
}

export function useMyOrders(
  opts: { page?: number; limit?: number; status?: string } = {},
  token?: string,
) {
  return useQuery({ ...myOrdersQuery(opts, token), enabled: !!token });
}

export function usePartialPaymentOrders(token?: string) {
  return useQuery({
    queryKey: queryKeys.me.orders({ page: 1, limit: 50, status: "partially_paid" }),
    queryFn: async () => {
      const data = await fetchMyOrders(
        { page: 1, limit: 50, status: "partially_paid" },
        token,
      );
      return data.items.filter((order) => order.status === "partially_paid");
    },
    enabled: !!token,
    staleTime: 30 * 1000,
  });
}

export function useMyStats(token?: string) {
  return useQuery({ ...myStatsQuery(token), enabled: !!token });
}
